module.exports = __webpack_public_path__ + "img/wallet_item.eec2f793.png";